
<template>
  <div>
    <router-view></router-view>
    <Loading v-show="loading"></Loading>
  </div>
</template>

<script>
import Loading from "./views/LoadingView.vue";
import { bus } from "./main";

export default {
  name: "App",
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
    };
  },
  created() {
    bus.$on("loading", (data) => {
      this.loading = data;
    });
  },
};
</script>
